import { type Message } from "atlas-shared"

import { ref } from "vue"

// #region Toast

export interface ToastEntry {
    id: number
    message: Message
}

let _toastIdCounter = 0
const toastMessages = ref<ToastEntry[]>([])

// #endregion

const messages = ref<Message[]>([])



export function useMessages() {

    function addMessage(msg: Message) {

        msg.datetime = new Date()
        msg.read = false
        messages.value.push(msg)

        const id = ++_toastIdCounter
        toastMessages.value.push({ id, message: msg })
        const duration = msg.type === 'error' ? 5000 : 4000
        setTimeout(() => dismissToast(id), duration)

    }

    function removeMessage(notification: Message) {

        const index = messages.value.indexOf(notification)
        if (index === -1) {
            return
        }

        messages.value.splice(index, 1)

    }

    function dismissToast(id: number) {
        const index = toastMessages.value.findIndex(t => t.id === id)
        if (index !== -1) toastMessages.value.splice(index, 1)
    }

    return {
        messages,
        addMessage,
        removeMessage,
        toastMessages,
        dismissToast,
    }
}